/**
 * Mega Menu functionality for Product menu
 * Handles hover interactions and content switching
 */

class MegaMenu {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () =>
        this.setupEventListeners()
      );
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Find all custom megamenu layouts
    const customMegamenus = document.querySelectorAll(
      '.mega-menu__custom-layout'
    );

    customMegamenus.forEach(megamenu => {
      this.setupMegamenu(megamenu);
    });
  }

  setupMegamenu(megamenu) {
    const categoryItems = megamenu.querySelectorAll(
      '.mega-menu__category-item'
    );
    const categoryContents = megamenu.querySelectorAll(
      '.mega-menu__category-content'
    );

    if (categoryItems.length === 0 || categoryContents.length === 0) {
      return;
    }

    // Hide all category contents initially
    this.removeActiveStates(categoryItems, categoryContents);

    // Add hover event listeners to category items
    categoryItems.forEach((item, index) => {
      const categoryHandle = item.dataset.category;
      const content = megamenu.querySelector(
        `[data-category="${categoryHandle}"]`
      );

      if (!content) return;

      // Mouse enter event
      item.addEventListener('mouseenter', e => {
        e.preventDefault();
        this.switchToCategory(item, content, categoryItems, categoryContents);
      });

      // Click event for mobile/touch devices
      item.addEventListener('click', e => {
        // Check if the click is on the link itself
        const link = item.querySelector('.mega-menu__category-link');
        const isLinkClick = link && link.contains(e.target);

        if (isLinkClick) {
          // Allow the link to navigate to its URL
          // Don't prevent default behavior for link clicks
          e.stopPropagation(); // Prevent event bubbling to parent handlers
          return;
        }

        // For clicks on the item (not the link), switch category content
        e.preventDefault();
        this.switchToCategory(item, content, categoryItems, categoryContents);
      });
    });

    // Add mouse leave event to the entire megamenu to prevent flickering
    megamenu.addEventListener('mouseleave', () => {
      // Keep the current active state on mouse leave
    });
  }

  switchToCategory(activeItem, activeContent, allItems, allContents) {
    // Remove active state from all items and contents
    this.removeActiveStates(allItems, allContents);

    // Set active state for the selected item and content
    this.setActiveCategory(activeItem, activeContent);
  }

  setActiveCategory(item, content) {
    // Add active class to the category item
    item.classList.add('mega-menu__category-item--active');
    const link = item.querySelector('.mega-menu__category-link');
    if (link) {
      link.classList.add('mega-menu__category-link--active');
    }

    // Show the corresponding content
    if (content) {
      content.style.display = 'block';
      content.classList.add('mega-menu__category-content--active');
    }
  }

  removeActiveStates(items, contents) {
    // Remove active state from all category items
    items.forEach(item => {
      item.classList.remove('mega-menu__category-item--active');
      const link = item.querySelector('.mega-menu__category-link');
      if (link) {
        link.classList.remove('mega-menu__category-link--active');
      }
    });

    // Hide all content areas
    contents.forEach(content => {
      content.style.display = 'none';
      content.classList.remove('mega-menu__category-content--active');
    });
  }
}

// Initialize the mega menu when the script loads
new MegaMenu();

// Also initialize when the page is fully loaded (for dynamic content)
window.addEventListener('load', () => {
  new MegaMenu();
});
